import React, { useEffect, useRef, useState } from "react"
import { Link } from "gatsby"
import { DENIED } from "./consent.js"

const categories = [
  [
    "analytics",
    "Анализ на посещенията",
    "Google Analytics ни помага да разберем кои страници се посещават. Не добавяме данни от формуляри или адресни параметри.",
  ],
  [
    "externalContent",
    "Външно съдържание",
    "Разрешава интерактивната карта на Google Maps. Адресът и контактите са достъпни и без нея.",
  ],
]

export default function ConsentBanner({
  consent,
  preferencesOpen,
  openPreferences,
  closePreferences,
  choose,
  error,
}) {
  const [draft, setDraft] = useState(consent)
  const heading = useRef(null)
  useEffect(() => {
    setDraft(consent)
  }, [consent, preferencesOpen])
  useEffect(() => {
    if (preferencesOpen) heading.current?.focus()
  }, [preferencesOpen])

  return (
    <section className="consent-panel" aria-labelledby="consent-heading">
      <h2 id="consent-heading" ref={heading} tabIndex={-1}>
        {preferencesOpen
          ? "Вашите настройки за поверителност"
          : "Вашият избор за поверителност"}
      </h2>
      <p>
        Използваме незадължителни услуги за статистика и интерактивна карта само
        с Ваше разрешение. Можете да откажете и да продължите да използвате
        сайта. <Link to="/privacy-policy/">Поверителност и бисквитки</Link>
      </p>
      {error && (
        <p className="consent-error" role="alert">
          {error}
        </p>
      )}
      {preferencesOpen && (
        <form
          id="consent-preferences"
          onSubmit={event => {
            event.preventDefault()
            choose(draft)
          }}
        >
          <fieldset>
            <legend>Категории услуги</legend>
            <div className="consent-category">
              <strong>Необходими — винаги включени</strong>
              <p>
                Показване на сайта и запазване на избора Ви за поверителност.
              </p>
            </div>
            {categories.map(([key, title, description]) => (
              <div className="consent-category" key={key}>
                <label>
                  <input
                    type="checkbox"
                    checked={draft[key]}
                    aria-describedby={`consent-${key}-description`}
                    onChange={event =>
                      setDraft({ ...draft, [key]: event.target.checked })
                    }
                  />
                  <strong>{title}</strong>
                </label>
                <p id={`consent-${key}-description`}>{description}</p>
              </div>
            ))}
          </fieldset>
        </form>
      )}
      <div className="consent-actions">
        <button
          type="button"
          onClick={() => choose({ analytics: true, externalContent: true })}
        >
          Приемам всички
        </button>
        <button type="button" onClick={() => choose(DENIED)}>
          Отказвам незадължителните
        </button>
        {preferencesOpen ? (
          <>
            <button type="submit" form="consent-preferences">
              Запазвам настройките
            </button>
            <button type="button" onClick={closePreferences}>
              Затварям без промяна
            </button>
          </>
        ) : (
          <button
            id="consent-open-preferences"
            type="button"
            onClick={openPreferences}
          >
            Настройки
          </button>
        )}
      </div>
    </section>
  )
}
